/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Détail du prix d\'une annonce diffusée (issu de la base annonces). Seuls les champs pertinents pour le type de transaction sont renseignés.
 */
export const prixDetailSchema = z.object({
      "prix_net_vendeur": z.number().describe("Prix net vendeur (vente)").optional(),
  "honoraires_negociation": z.number().describe("Honoraires de négociation (vente)").optional(),
  "charge_negociation": z.string().describe("Partie supportant les honoraires de négociation (acquereur, vendeur)").optional(),
  "loyer_mensuel_hors_charges": z.number().describe("Loyer mensuel hors charges (location)").optional(),
  "montant_charges": z.number().describe("Montant mensuel des charges (location)").optional(),
  "depot_garantie": z.number().describe("Dépôt de garantie (location)").optional()
      }).describe("Détail du prix d'une annonce diffusée (issu de la base annonces). Seuls les champs pertinents pour le type de transaction sont renseignés.")